/*
 * Routed Component
 */
(function() {
  'use strict';

  var launchConsole = {
    templateUrl: 'app/entities/launch-console/launch-console.html',
    bindings: {
      onResolveDisabled: '&',   // [UI-VIEW.ATTR]
      onResolveProperties: '&', // [UI-VIEW.ATTR] this is how child state return possible properties to parent
      properties: '<',          // [THIS.RESOLVE] passed in from state.resolve 
      propertyId: '<',          // [PARENT.RESOLVE] user selection, inherited from app.prop
    },
    controller: 'LaunchConsoleController'
  };

  angular
    .module('tyallsApp')
    .component('launchConsole', launchConsole)
    .config(['$stateProvider', function($stateProvider) {
      $stateProvider
        .state('app.prop.launch-console', {
          url: '/launch-console',
          redirectTo: 'app.prop.launch-console.daily-launcher',
          views: {
            'prop@^' : 'launchConsole',
          },
          data: {
            authorities: [],
            pageTitle: 'LaunchConsole'
          },
          resolve: {
            // override the property list fetched in parent
            properties: [ 'PropertyService', function(PropertyService) {
              return PropertyService.getAllPropertiesForUser()
                .then(function(response) {
                  return response.data; 
                });
            }],
          }
        })

    }]);
})();
